module.exports = __webpack_public_path__ + "static/tag-cb038c0652235be073a713f659d7b820.gif";